import { Auth } from "../auth/Auth";
const API_KEY = process.env.REACT_APP_API_KEY;

export const headers = {
  "x-access-token": Auth.token(),
  "x-api-key": API_KEY,
};
